const initialState = {
  submitting: false
}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'CANCELLATION_REQUEST':
      return {
        ...state,
        submitting: true
      }

    case 'CANCELLATION_ERROR':
      return {
        ...state,
        submitting: false
      }

    case 'CANCELLATION_DONE':
      return {
        ...state,
        submitting: false
      }
    default:
      return state
  }
}
